export const dataTableFilterData = [
  {
    "filterGroup": "Inventory Status",
    "filterGroupType": "checkbox",
    "filterGroupName": "status",
    "filterGroupInputs": [
      {
        "filterTitle": "In Stock",
        "filterValue": "inStock",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Low Stock",
        "filterValue": "lowStock",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Out of Stock",
        "filterValue": "outOfStock",
        "filterOperator": "equal",
        "active": false
      },
    ],
  },
  {
    "filterGroup": "Date Range",
    "filterGroupType": "radio",
    "filterGroupName": "fixedRange",
    "filterGroupInputs": [
      {
        "filterName": "fixedRange",
        "filterTitle": "Today",
        "filterValue": "today",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Yesterday",
        "filterValue": "yesterday",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Last 7 Days",
        "filterValue": "lastSevenDays",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Last 60 Days (Default)",
        "filterValue": "lastSixtyDays",
        "filterOperator": "equal",
        "active": true
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Custom Date Range",
        "filterValue": "customRange",
        "filterOperator": "equal",
        "active": false,
        "childFilters":[
          {
            "filterGroup": "Date Range",
            "filterGroupType": "dateRange",
            "filterGroupName": "dateRange",
            "dateRangeNameStart": "startDate",
            "dateRangeNameEnd": "endDate",
          }
        ]
      },
    ],
  }
];


// WEBPACK FOOTER //
// ./src/components/lookupTable/stores/testFilterData.js